import styled from "styled-components"
import { boxShadow, displays, textuppercase } from "theme/base/Variables"
import { CardItemStyled } from "theme/common/CardItem.styled"

export const ContentOrderItemstyled = styled.div<{ selected?: boolean }>`
  ${displays.flexBase};
  background: ${({ theme, selected }) => (selected ? theme.palette.grey10 : theme.palette.grey5)};
  border-radius: 13px;

  & .content-order-checked {
    ${displays.flexCenter};
    padding-left: 0.5rem;
  }

  &:hover {
    ${boxShadow.shadow02};
  }
`

export const CardOrderItemStyled = styled(CardItemStyled)`
  position: relative;
  padding: 0.5rem;
  padding-right: 2.5rem;
  width: 100%;

  &.has-debt {
    padding: 2rem 0.5rem 0.5rem;

    & .info-label {
      color: #ffffff;
      background: #ED1E79;
      font-size: 0.8rem;
      position: absolute;
      top: 7px;
      left: 6px;
      padding: 0 4px;
    }
  }

  & .content-item-order {
    ${displays.flexColumn}
    align-items:flex-start;
    gap: 0.3rem;
    padding-right: 0.5rem;

    & > .item {
      ${displays.flexBase};
      gap: 0.3rem;
      font-size: 0.714rem;
      color: ${({ theme }) => theme.palette.grey60};
      ${textuppercase};
      max-width: 100%;
      flex-wrap: wrap;

      &:first-child {
        font-size: 0.8rem;
      }

      & span {
        color: ${({ theme }) => theme.palette.grey90};
        font-weight: bold;
      }
    }
  }
  & .tag {
    ${displays.flexBase};
    gap: 5px;
    position: absolute;
    bottom: 0.5rem;
    right: 2.5rem;
    font-size: 0.714rem;
    white-space: nowrap;
    color: ${({ theme }) => theme.palette.grey60};
    ${textuppercase};
    & > svg {
      font-size: 1.5rem;
    }
  }

  & .icon-arrow-rigth {
    position: absolute;
    color: ${({ theme }) => theme.palette.secondary};
    font-size: 1.5rem;
    right: 5px;
  }
  & .icon-storepickup-item {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 28px; //6
    right: 8px;
  }

  & .icon-is_search_approval {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 6px;
    right: 35px;
  }

  & .icon-packgeimport-item {
    color: #ED1E79;
    font-size: 1.6rem;
    position: absolute;
    top: 52px; //30
    right: 6px;
  }

  & .icon-storepickup-meson {
    color: #ED1E79;
    font-size: 1.4rem;
    position: absolute;
    top: 54px; //32
    right: 7px;
  }

  & .icon-storepickup-express-delivery {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 81px; //59
    right: 8px;
  }

  & .icon-delivery-ultra-express {
    color: #ED1E79;
    font-size: 1.3rem;
    position: absolute;
    top: 101px; //79
    right: 8px;
  }

  & .pending-label {
    color: #ffffff;
    background: #ED1E79;
    font-size: 0.8rem;
    position: absolute;
    top: 7px;
    right: 6px;
    padding: 0 4px;

    &.close {
      background: #666666;
    }
  }

  & .label-plan-zero {
    display: inline-block;
    background: linear-gradient(90deg, #5a0070, #8a00a8);
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 6px;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }
    
`
